/*
 * Copyright (c) 2024-2025. Haodong JU
 */

import { VTextField } from 'vuetify/lib/components'
import { createDisplayInfoFormFields } from './membershipBenefitFormSchema'

/**
 * Returns the form schema for the membership level form
 *
 * @returns {Array} The form schema
 */
export function getMembershipLevelFormSchema () {
  return [
    ...createDisplayInfoFormFields({
      useNestedKeys: false,
      imageKey: 'file',
      nameHint: '会员等级名称',
      descriptionHint: '会员等级描述',
      colorHint: '会员等级颜色',
      imageHint: '会员等级图片'
    }),
    {
      name: '所需积分',
      key: 'requiredPoints',
      component: VTextField,
      required: true,
      hint: '达到此等级所需的积分',
      componentProps: {
        type: 'number'
      }
    }
  ]
}
